import omitJS from './omitJS'

const omit = <T>(
  obj: Record<string | number | symbol, T>,
  paths: string[]
): Record<string | number | symbol, T> => omitJS(obj, paths)

export default omit
